import { Link } from 'react-router-dom';
import { tr } from '@/lib/i18n-core';
import { useAuth } from '@/lib/auth';
import { Alert } from '@/components/ui/primitives';

export interface ConsultationInvoiceRef {
  id: string;
  number: string;
  status: string;
}

export function consultationFeeUnbilled(encounter: { context: string; status: string; consultationInvoice?: ConsultationInvoiceRef | null }): boolean {
  return encounter.context === 'opd' && encounter.status !== 'closed' && encounter.consultationInvoice === null;
}

export function ConsultationFeeAlert({
  encounter,
  className,
}: {
  encounter: { id: string; context: string; status: string; consultationInvoice?: ConsultationInvoiceRef | null };
  className?: string;
}) {
  const { can } = useAuth();
  if (!consultationFeeUnbilled(encounter)) return null;
  return (
    <Alert variant="warning" title={tr('opd', 'consultation_fee_not_billed_yet')} className={className}>
      {tr('opd', 'the_first_order_bills_the_consultation_fee')}
      {can('invoice.read') && (
        <>
          {' '}
          <Link to={`/billing/statement?encounterId=${encounter.id}`} className="font-medium underline underline-offset-2">
            {tr('opd', 'open_the_statement')}
          </Link>
        </>
      )}
    </Alert>
  );
}
